// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"8d0781f9","541":"c5b70bf0","641":"8b0c3bd2","706":"877ae733"}[chunkId] + ".chunk.js";
};